import { BaseError } from "@core/foundation/error";

export class JsonWriteConflictError extends BaseError {
  public override readonly name = "JsonWriteConflictError";
}
